/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free boiling point calculator using the Antoine equation. Find a solvent's boiling point at any pressure, or its vapor pressure at any temperature.`)
};

const es_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de punto de ebullición gratuita con la ecuación de Antoine. Encuentra el punto de ebullición de un disolvente a cualquier presión, o su presión de vapor a cualquier temperatura.`)
};

const de_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Siedepunkt-Rechner nach der Antoine-Gleichung. Ermitteln Sie den Siedepunkt eines Lösungsmittels bei beliebigem Druck oder seinen Dampfdruck bei beliebiger Temperatur.`)
};

const nl_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis kookpuntcalculator op basis van de Antoine-vergelijking. Bereken het kookpunt van een oplosmiddel bij elke druk, of de dampspanning bij elke temperatuur.`)
};

const fr_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de point d'ébullition gratuit utilisant l'équation d'Antoine. Trouvez le point d'ébullition d'un solvant à n'importe quelle pression, ou sa pression de vapeur à n'importe quelle température.`)
};

const it_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito del punto di ebollizione basato sull'equazione di Antoine. Trova il punto di ebollizione di un solvente a qualsiasi pressione, o la sua tensione di vapore a qualsiasi temperatura.`)
};

const pt_br2_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de ponto de ebulição usando a equação de Antoine. Encontre o ponto de ebulição de um solvente em qualquer pressão, ou sua pressão de vapor em qualquer temperatura.`)
};

const pt_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de ponto de ebulição gratuita, com base na equação de Antoine. Determine o ponto de ebulição de um solvente a qualquer pressão, ou a sua pressão de vapor a qualquer temperatura.`)
};

const ja_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アントワン式を用いた無料の沸点計算機です。任意の圧力での溶媒の沸点、または任意の温度での蒸気圧を求められます。`)
};

const zh_bp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于安托万方程的免费沸点计算器。求解溶剂在任意压力下的沸点，或在任意温度下的蒸气压。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_meta_description", locale)
	if (locale === "en") return en_bp_meta_description(inputs)
	if (locale === "es") return es_bp_meta_description(inputs)
	if (locale === "de") return de_bp_meta_description(inputs)
	if (locale === "nl") return nl_bp_meta_description(inputs)
	if (locale === "fr") return fr_bp_meta_description(inputs)
	if (locale === "it") return it_bp_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bp_meta_description(inputs)
	if (locale === "pt") return pt_bp_meta_description(inputs)
	if (locale === "ja") return ja_bp_meta_description(inputs)
	return zh_bp_meta_description(inputs)
};